<template>
  <v-row justify="center">
    <v-dialog scrim="rgba(0, 0, 0, 0.8)" v-model="dialog" :fullscreen="fullscreen" persistent :max-width="max_width"
      :max-height="max_height" transition="dialog-bottom-transition">
      <v-card class="global-radius outfit-font">
        <v-toolbar dark :color="color ? color : 'info'">
          <template v-if="$slots.toolbar">
            <slot name="toolbar"/>
          </template>
          <template v-else>
            <v-toolbar-title :text="title" />
            <v-btn icon='mdi-close' dark @click="$emit('close')" />
          </template>
        </v-toolbar>
        <slot></slot>
        <div class="d-flex pa-2" :color="footer_color" v-if="$slots.footer">
          <slot name="footer"/>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue'

const props = defineProps<{
  visible?: boolean
  title?: string
  fullscreen?: boolean
  max_width?: string | number
  max_height?: string | number
  color?: string
  footer_color?: string
}>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'onmount'): void
}>()

const dialog = ref(false)

onMounted(() => {
  dialog.value = !!props.visible
  emit('onmount')
})

watch(() => props.visible, (newVal) => {
  dialog.value = !!newVal
})
</script>
